import { AxiosPromise } from 'axios';
import { CustomerInvitationsLookUpResultType } from 'src/app/services/registerInvitations/registerInviations-service.type';
import { axios } from 'src/app/utils';
import { finalUrlsConfig } from 'src/configs/url.config';

// export const userAllRegisterInvitation = (
//   customerId: string,
//   options?: {
//     blockErrorHandler: boolean;
//   }
// ): AxiosPromise<servicesUserTypes.UserLookupResultType> => {
//   return axios.get(
//     finalUrlsConfig().user.userRegisterInvitationsLookUp /*+`/${customerId}` */,
//     options
//   );
// };

export const lookUpRegisterInvitations = (
  customerId?: string,
  options?: {
    blockErrorHandler: boolean;
  },
): AxiosPromise<CustomerInvitationsLookUpResultType> => {
  return axios.get(finalUrlsConfig().user.userAllRegisterInvitation /* +`/${customerId}` */, options);
};

export const sendRegisterInvitation = (
  email: string,
  customerId: string,
  options?: { blockErrorHandler: boolean },
): AxiosPromise<undefined> => {
  return axios.post(finalUrlsConfig().user.sendRegisterInvitation, { email, customerId }, options);
};

export default {
  // userAllRegisterInvitation,
  sendRegisterInvitation,
  lookUpRegisterInvitations,
};
